// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WtQm","left":"styles_left__3Zmb9"};